<div class="bg-white rounded-lg shadow-sm p-6 border border-gray-200 h-full">
  <!-- Sync Date Info Section -->
  <div *ngIf="syncDate" class="mb-4 px-4 py-2 rounded-lg border bg-gray-50 border-gray-200">
    <div class="flex items-center space-x-2">
      <mat-icon class="text-sm text-blue-600">info</mat-icon>
      <span class="text-sm text-gray-700">
        Data retrieved from official government sources as of
        <span class="font-semibold">{{ formattedSyncDate }}</span
        >.
      </span>
    </div>
  </div>

  <div class="flex items-center mb-5">
    <div
      class="w-5 h-5 rounded-full mr-4 relative"
      [ngClass]="hasRecords ? 'bg-green-500' : 'bg-red-500'"
    >
      <div
        class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-white rounded-full"
      ></div>
    </div>
    <h2 class="text-xl font-poppins font-semibold text-[#E53935] mb-0">
      Income Tax Exemption Compliance
    </h2>
  </div>

  <div class="space-y-3">
    <div class="flex justify-between items-center py-3 border-b border-gray-100">
      <span class="font-poppins font-medium text-[#4B4B4B]">Filing Status</span>
      <span
        class="px-3 py-1 rounded-full text-xs font-poppins font-semibold"
        [ngClass]="hasRecords ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'"
      >
        {{ hasRecords ? 'COMPLIANT' : 'NOT FOUND' }}
      </span>
    </div>

    <div class="flex justify-between items-center py-3 border-b border-gray-100">
      <span class="font-poppins font-medium text-[#4B4B4B]">Exemption Records</span>
      <span class="font-poppins text-[#0E1116]">{{ incometaxData.length }} Active Records</span>
    </div>

    <div class="flex justify-between items-center py-3 border-b border-gray-100">
      <span class="font-poppins font-medium text-[#4B4B4B]">12A Assessment Year</span>
      <span class="font-poppins text-[#0E1116]">{{
        section12ARecord?.ayDateFromRegistered || 'N/A'
      }}</span>
    </div>

    <div class="flex justify-between items-center py-3 border-b border-gray-100">
      <span class="font-poppins font-medium text-[#4B4B4B]">12A Registration</span>
      <span class="font-poppins text-[#0E1116]">{{
        section12ARecord?.dateOfRegistration || firstRecord?.dateOfRegistration || 'N/A'
      }}</span>
    </div>

    <div class="flex justify-between items-center py-3">
      <span class="font-poppins font-medium text-[#4B4B4B]">12A Validity</span>
      <span
        *ngIf="expirationDetail12A"
        class="px-3 py-1 rounded-full text-xs font-poppins font-semibold"
        [ngClass]="expirationDetail12A.status.className"
      >
        Expires: {{ expirationDetail12A.expirationDate }} ({{ expirationDetail12A.timeRemaining }})
      </span>
      <span
        *ngIf="!expirationDetail12A"
        class="px-3 py-1 rounded-full text-xs font-poppins font-semibold bg-gray-100 text-gray-800"
      >
        N/A
      </span>
    </div>

    <div class="flex justify-between items-center py-3 border-b border-gray-100">
      <span class="font-poppins font-medium text-[#4B4B4B]">12A URN</span>
      <span class="font-poppins text-[#0E1116]">{{
        section12ARecord?.uniqueRegistrationNumber || 'N/A'
      }}</span>
    </div>

    <div class="flex justify-between items-center py-3 border-b border-gray-100">
      <span class="font-poppins font-medium text-[#4B4B4B]">80G Assessment Year</span>
      <span class="font-poppins text-[#0E1116]">{{
        section80GRecord?.ayDateFromRegistered || 'N/A'
      }}</span>
    </div>

    <div class="flex justify-between items-center py-3 border-b border-gray-100">
      <span class="font-poppins font-medium text-[#4B4B4B]">80G Registration</span>
      <span class="font-poppins text-[#0E1116]">{{
        section80GRecord?.dateOfRegistration || 'N/A'
      }}</span>
    </div>

    <div class="flex justify-between items-center py-3">
      <span class="font-poppins font-medium text-[#4B4B4B]">80G Validity</span>
      <span
        *ngIf="expirationDetail80G"
        class="px-3 py-1 rounded-full text-xs font-poppins font-semibold"
        [ngClass]="expirationDetail80G.status.className"
      >
        Expires: {{ expirationDetail80G.expirationDate }} ({{ expirationDetail80G.timeRemaining }})
      </span>
      <span
        *ngIf="!expirationDetail80G"
        class="px-3 py-1 rounded-full text-xs font-poppins font-semibold bg-gray-100 text-gray-800"
      >
        N/A
      </span>
    </div>

    <div class="flex justify-between items-center py-3 border-b border-gray-100">
      <span class="font-poppins font-medium text-[#4B4B4B]">80G URN</span>
      <span class="font-poppins text-[#0E1116]">{{
        section80GRecord?.uniqueRegistrationNumber || 'N/A'
      }}</span>
    </div>
  </div>
</div>
